import { Component, OnInit } from '@angular/core';
import {  } from 'primeng/api';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
	isAuthenticated: boolean = false;

	constructor(private router: Router){

	}

	ngOnInit() {
	    if(sessionStorage.getItem("token")){
	        let obj = JSON.parse(sessionStorage.getItem("token"));
	        if(obj && obj.Token != ""){
	          this.isAuthenticated = true;
	        }
	    }
	}
  

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts